import { S_PageStyle } from 'pages/page/PageStyle';
import { FileForm } from 'pages/special/ImportPage/FileForm';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const ImportKmzPage = (props: Props): JSX.Element => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    return (
        <S_ImportPage className={props.className}>
            <FileForm
                style={{ display: loading ? 'none' : 'block' }}
                onFileSelected={() => {
                    setLoading(true);
                }}
                onFileUploaded={(guideId) => {
                    navigate('/admin/' + guideId);
                }}
            />
            {loading && <>Loading ...</>}
        </S_ImportPage>
    );
};

const S_ImportPage = styled(S_PageStyle)``;
